import * as Yup from "yup";

export const dataModel = {
  hourMen: "",
  stopTime: "",
};

export const validationDataModel = () => {
  return Yup.object().shape({
    hourMen: Yup.number().required("forms.validations.required"),
    stopTime: Yup.number().optional("forms.validations.required"),
  });
};

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
